module.exports = __webpack_public_path__ + "static/media/logo.8fa55772.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/logo.svg
// module id = 39
// module chunks = 0